import validation from '../../../services/validation';
import { validationSettings } from './contants';

export function CoworkingFloorCtrl($rootScope, deviceService, addFormService, coworkingService) {
  'ngInject';
  this.isMobile = deviceService.isMobile;
  this.isFlexOffice = coworkingService.isFlexOffice();

  if (!addFormService.isFieldExisted('building')) {
    addFormService.setValueByPath('building', {});
  }

  this.isOtherFloorsEnabled = !this.isFlexOffice && (!!this.ad.floorFrom || !!this.ad.floorTo);

  this.floorsCountBlured = false;
  this.floorNumberBlured = false;
  this.floorFromBlured = false;
  this.floorToBlured = false;

  this.minFloorNumber = -3;
  this.maxFloorNumber = 999;
  this.maxFloorsCount = 999;

  this.onCheckboxChanged = () => {
    if (this.isOtherFloorsEnabled) {
      addFormService.setValueByPath('floorNumber', undefined);
      return;
    }

    addFormService.setValueByPath('floorFrom', undefined);
    addFormService.setValueByPath('floorTo', undefined);
  };

  this.onCheckboxChanged();

  this.getMinFloorsCount = () => {
    if (this.floorsCountBlured && (this.floorNumberBlured || this.floorToBlured)) {
      const minFloorsField = this.isOtherFloorsEnabled ? this.ad.floorTo : this.ad.floorNumber;

      return minFloorsField ? Math.max(1, minFloorsField) : 1;
    }

    return 0;
  };

  const isBothRequired = () => {
    if (this.isOtherFloorsEnabled) {
      return this.floorFromValidation.invalid() && this.getFloorToValidation().invalid() ||
      this.getFloorToValidation().invalid() && this.getFloorsCountValidation().invalid() ||
      this.floorFromValidation.invalid() && this.getFloorsCountValidation().invalid();
    }

    return this.floorNumberValidation.invalid() && this.getFloorsCountValidation().invalid() &&
          this.form.floorNumber.$error.required && this.form.floorsCount.$error.required;
  };

  const isInvalid = () => {
    const floorsCount = this.ad.building.floorsCount;

    if (this.floorsValidation && floorsCount !== null && this.ad.floorTo !== null) {
      return floorsCount < this.ad.floorTo;
    }

    if (this.floorsValidation && this.ad.floorTo !== null && this.ad.floorFrom !== null) {
      return this.ad.floorTo < this.ad.floorFrom;
    }

    if (this.floorsValidation && floorsCount !== null && this.ad.floorNumber !== null) {
      return floorsCount < this.ad.floorNumber;
    }

    return false;
  };

  this.floorFromValidation = validation(this.form, 'floorFrom', {
    ...validationSettings,
    min: `Этаж должен быть больше ${this.minFloorNumber}`,
  });

  this.getFloorToValidation = () => validation(this.form, 'floorTo', {
    ...validationSettings,
    min: `Этаж должен быть больше ${Math.max(1, this.ad.floorFrom)}`,
  });

  this.floorNumberValidation = validation(this.form, 'floorNumber', {
    ...validationSettings,
    min: `Этаж должен быть больше ${this.minFloorNumber}`,
  });

  this.getFloorsCountValidation = () => validation(this.form, 'floorsCount', {
    ...validationSettings,
    min: `Количество этажей не может быть меньше ${Math.max(1, this.ad.floorNumber || this.ad.floorTo || 0)}`,
  });

  const setMinFloorsCountValidation = () => {
    this.floorsValidation = validation(this.form, 'floorsCount', {
      min: 'Этаж объекта недвижимости должен быть меньше или равен этажности здания',
    });
  };

  this.blurField = field => {
    switch (field) {
      case 'floorsCount':
        this.floorsCountBlured = true;
        break;
      case 'floorNumber':
        this.floorNumberBlured = true;
        break;
      case 'floorFrom':
        this.floorFromBlured = true;
        break;
      case 'floorTo':
        this.floorToBlured = true;
        break;
      default:
        return;
    }

    if (this.floorsCountBlured && this.floorNumberBlured) {
      setMinFloorsCountValidation();
    }

    if (this.floorsCountBlured && this.floorFromBlured) {
      setMinFloorsCountValidation();
    }
  };

  this.floorFromValidationInvalid = () => {
    return this.floorFromValidation.invalid() || isInvalid();
  };

  this.floorFromValidationShowTooltip = () => {
    return this.floorFromValidation.invalid() && !isBothRequired();
  };

  this.floorToValidationInvalid = () => {
    return this.getFloorToValidation().invalid() || isInvalid();
  };

  this.floorToValidationShowTooltip = () => {
    return this.getFloorToValidation().invalid() && !isBothRequired();
  };

  this.floorNumberValidationInvalid = () => {
    return this.floorNumberValidation.invalid() || isInvalid();
  };

  this.floorNumberValidationShowTooltip = () => {
    return this.floorNumberValidation.invalid() && !isBothRequired();
  };

  this.floorsCountValidationInvalid = () => {
    return this.getFloorsCountValidation().invalid() || isInvalid();
  };

  this.floorsCountValidationShowTooltip = () => {
    return this.floorsCountValidationInvalid() && (!this.floorNumberValidation.invalid() || isBothRequired());
  };

  this.floorsCountValidationMessage = () => {
    let message;
    if (isBothRequired()) {
      message = 'Укажите этаж и количество этажей в доме';
    } else if (isInvalid()) {
      message = this.floorsValidation.message();
    } else {
      message = this.getFloorsCountValidation().message();
    }
    return message;
  };

  $rootScope.$on('addform.submit', () => {
    setMinFloorsCountValidation();

    if (isInvalid()) {
      if (this.isOtherFloorsEnabled) {
        this.floorFromBlured = true;
        this.floorToBlured = true;
      } else {
        this.floorNumberBlured = true;
      }

      this.floorsCountBlured = true;
    }
  });
}
